import { render, staticRenderFns } from "./BaseModalPassword.vue?vue&type=template&id=19d31364&"
import script from "./BaseModalPassword.vue?vue&type=script&lang=js&"
export * from "./BaseModalPassword.vue?vue&type=script&lang=js&"
import style0 from "./BaseModalPassword.vue?vue&type=style&index=0&id=19d31364&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports